define(['app', 'jquery', 'underscore', 'libs/helpers/screen-sizes'], function (
  app,
  $,
  _,
  screenSizes
) {
  return app.Marionette.ItemView.extend({
    template: false,

    options: {
      trigger: 'hover',
      timeOpen: 200,
      windowPadding: 14,
      arrow: '<i class="arrow"></i>',
      triggerActiveClass: 'is-active',
      disableOnMobile: false,
      fitInViewport: true,
      classes: [
        'position--top',
        'position--bottom',
        'position--left',
        'position--right',
        'position--center'
      ]
    },

    ui: {
      trigger: '.js-tooltip-trigger',
      hoverTrigger: '.js-tooltip-trigger, .js-tooltip-content',
      tooltip: '.js-tooltip-content'
    },

    events: function () {
      if (this.options.trigger === 'click') {
        return {
          'click @ui.trigger': 'toggleTooltip'
        }
      }
      return {
        'mouseenter @ui.hoverTrigger': 'showTooltip',
        'mouseleave @ui.hoverTrigger': 'onMouseLeave'
      }
    },

    getPositionInformation: function () {
      if (!this.ui.tooltip) return

      var viewportHeight = this.options.fitInViewport
        ? window.innerHeight
        : this.$body.height() - this.$body.scrollTop()
      var viewportWidth = this.$window.width()

      this.ui.tooltip.addClass('is-enabled')
      var rect = this.ui.tooltip[0].getBoundingClientRect()

      return {
        noTopSpace: rect.top < 0,
        noBottomSpace: rect.bottom > viewportHeight,
        fitsHeight: rect.height < viewportHeight,
        left: rect.left,
        right: viewportWidth - rect.right
      }
    },

    redraw: function () {
      var positionInfo = this.getPositionInformation()
      var absoluteArrowPosition = positionInfo.left
      var needsUpdate = this.firstDraw
      this.firstDraw = false

      if (positionInfo.fitsHeight && positionInfo.noBottomSpace) {
        needsUpdate = true
        this.className = 'position--top'
        this.marginTop = this.getTooltipTopMargin()
      }

      if (positionInfo.fitsHeight && positionInfo.noTopSpace) {
        needsUpdate = true
        this.className = 'position--bottom'
        this.marginTop = 0
      }

      if (positionInfo.left < 0) {
        needsUpdate = true
        this.marginLeft += -positionInfo.left + this.options.windowPadding
        absoluteArrowPosition = this.options.windowPadding
      }

      if (positionInfo.right < 0) {
        needsUpdate = true
        this.marginLeft += positionInfo.right - this.options.windowPadding
        absoluteArrowPosition =
          positionInfo.left + positionInfo.right - this.options.windowPadding
      }

      if (!needsUpdate) return

      this.ui.tooltip.css({
        'margin-left': this.marginLeft,
        'margin-top': this.marginTop
      })

      this.setArrowPosition(absoluteArrowPosition)

      this.ui.tooltip.removeClass(this.options.classes.join(' '))
      this.ui.tooltip.addClass(this.className)
    },

    setArrowPosition: function (tooltipOffset) {
      var rect = this.ui.trigger.offset()
      var triggerCenter = rect.left + this.ui.trigger.outerWidth() / 2
      var margin = triggerCenter - tooltipOffset
      this.ui.arrow.css({ left: margin })
    },

    showTooltip: function () {
      if (this.options.disableOnMobile && screenSizes.isLessThanMedium()) { return }
      if (this.hideTimeout) clearTimeout(this.hideTimeout)
      if (this.visible) return false

      this.redraw()
      this.ui.tooltip.addClass('is-active is-enabled')
      this.visible = true

      if (this.options.trigger === 'click') {
        this.ui.trigger.addClass(this.options.triggerActiveClass)
        $(document).on('click', this.onDocumentClick)
      }
    },

    onDocumentClick: function (e) {
      if (!this.ui.hoverTrigger.has(e.target).length) this.hideTooltip()
    },

    hideTooltip: function () {
      this.ui.trigger.removeClass(this.options.triggerActiveClass)
      this.ui.tooltip.removeClass('is-active is-enabled')
      this.visible = false
      $(document).off('click', this.onDocumentClick)
    },

    toggleTooltip: function (e) {
      e.stopPropagation()
      if (this.visible) return this.hideTooltip()
      this.showTooltip()
    },

    getTooltipTopMargin: function () {
      var tooltipHeight = this.ui.tooltip.outerHeight()
      var triggerHeight = this.ui.trigger.outerHeight()
      var arrowHeight = this.ui.arrow.height() || 0
      return -(tooltipHeight + triggerHeight + 2 * arrowHeight)
    },

    onMouseLeave: function () {
      var self = this

      if (this.hideTimeout) clearTimeout(this.hideTimeout)
      this.hideTimeout = setTimeout(function () {
        self.hideTooltip()
      }, self.options.timeOpen)
    },

    onWindowResize: function () {
      if (this.visible) this.redraw()
    },

    onRender: function () {
      this.marginLeft = 0
      this.className = 'position--bottom'
      this.visible = false
      this.firstDraw = true

      this.ui.arrow = $(this.options.arrow).prependTo(this.ui.tooltip)
      this.ui.trigger.attr('aria-haspopup', true) // fix for MS windows touch devices
    },

    initialize: function () {
      this.$window = $(window)
      this.$body = $('body')
      this.$window.on(
        'resize',
        _.debounce(this.onWindowResize.bind(this), 100)
      )

      this.onDocumentClick = this.onDocumentClick.bind(this)
    }
  })
})
